import { render, staticRenderFns } from "./company.children.list.panel.vue?vue&type=template&id=2df6c456&scoped=true&"
import script from "./company.children.list.panel.vue?vue&type=script&lang=js&"
export * from "./company.children.list.panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6c456",
  null
  
)

export default component.exports